export const ModalSizes = Object.freeze({
  ExtraSmall: "xs",
  Small: "sm",
  Medium: "md",
  Large: "lg",
});

export const ModalSizeOptions = Object.values(ModalSizes);
